<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="9" class="d-flex justify-start align-center"><h2>Profile</h2></v-col>
      </v-row>
    </v-col>

    <v-col cols="12">
      <v-tabs v-model="tab">
        <v-tab href="#form-update">Ubah Data</v-tab>
        <v-tab href="#form-change-password">Ubah Password</v-tab>
      </v-tabs>
    </v-col>

    <v-col cols="12">
      <v-tabs-items v-model="tab">
        <v-tab-item value="form-update"><FormUpdate :user="user" :setAlert="setAlert" /></v-tab-item>
        <v-tab-item value="form-change-password"><FormChangePassword :setAlert="setAlert" /></v-tab-item>
      </v-tabs-items>
    </v-col>

    <v-snackbar v-model="alert.status" :timeout="timeout" :color="alert.success ? 'success' : 'error'" right bottom>
      {{ alert.message }}
    </v-snackbar>
  </v-row>
</template>

<script>
import { mdiSquareEditOutline, mdiDotsVertical, mdiRefresh, mdiFileOutline } from '@mdi/js'
import axios from 'axios'
import { shortlessDateTime } from '@/utils'
import FormUpdate from './components/FormUpdate.vue'
import FormChangePassword from './components/FormChangePassword.vue'

export default {
  components: { FormUpdate, FormChangePassword },
  setup() {
    return {
      // icons
      icons: {
        mdiSquareEditOutline,
        mdiDotsVertical,
        mdiRefresh,
        mdiFileOutline,
      },
    }
  },
  computed: {
    user() {
      return JSON.parse(localStorage.getItem('user'))
    },
  },
  data() {
    return {
      alert: {
        status: false,
        success: false,
        message: '',
      },
      timeout: 1200,
      loadingTable: false,
      total: 0,
      tab: null,
    }
  },
  mounted() {},
  methods: {
    setAlert(value) {
      this.alert = value
    },
  },
}
</script>

<style>
</style>